module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Rec-f93d63f30f88c5c3d1faf16a59347e03.svg";